import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import YearPicker from "../../../../components/Calendar/YearPicker";
import getFormValidations from "./formValidations";
import { toggleCalendar } from "../../actions";
import {getModule, getLanguage, getDatePickerOpened} from "../../selectors";

// startYear / endYear bound the selectable years (endYear defaults to the current year)
function yearComparator(startYear, endYear) {
  return year => (Number.isInteger(startYear) && year < startYear) || (Number.isInteger(endYear) && year > endYear)
}

// binding for redux-form
const VisualComponent = ({
  input: { value, onChange },
  meta: { touched, error },
  open,
  path,
  required,
  onOpenChange,
  startYear,
  endYear,
  disabled,
  editable,
  t
}) => {
  const translatedError = t(error)
  return (
    <YearPicker
      value={value}
      path={path}
      required={required}
      onChange={value => onChange(value)}
      open={open}
      onOpenChange={onOpenChange}
      disabledYear={yearComparator(startYear, endYear)}
      touched={touched}
      error={translatedError}
      language={"fr"}
      disabled={!editable || disabled}
      t={t}
    />
  );
};

const YearPickerComponent = ({ field, language, module, open, toggleCalendar, t, objectMode }) => {
  const validations = getFormValidations(field);
  return (
    <Field
      name={field.path}
      path={field.tKey || field.path}
      required={field.required}
      component={VisualComponent}
      open={open}
      onOpenChange={() => toggleCalendar(field.id)}
      validate={validations}
      startYear={field.startYear}
      endYear={field.endYear === undefined ? new Date().getFullYear() : field.endYear}
      disabled={field.disabled || !field.writable}
      editable={!field.editable ? objectMode === 'newObject' : field.editable}
      language={language}
      module={module}
      t={t}
    />
  );
};

const mapStateToProps = (state, { field }) => ({
  open: getDatePickerOpened(state, field.id),
  language: getLanguage(state),
  module: getModule
});

const mapDispatchToProps = {
  toggleCalendar
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(YearPickerComponent);
